import type { App, Plugin } from 'vue'
// 出网铁律: @umengfe/apm 的 init() 会向友盟 APM 服务器上报, 属禁止外呼;
// 同时它注册的 unload 监听触发了浏览器 "Permissions policy violation: unload is not allowed"。
// 已停用上报, 仅保留错误打印, 便于本地排障。
// import { init, captureException } from '@umengfe/apm'
// import { APPKEY, IGNORE_ERROR } from '@/constants/umeng'
// import { currentDev } from '@/config/env'

const umengPlugin: Plugin = {
  install(app: App) {
    // const env = currentDev === 2 ? 'TEST' : 'PROD'
    // init({
    //   pid: APPKEY[env],
    //   tag: 'app',
    //   errorFilter: {
    //     mode: 'ignore',
    //     rules: IGNORE_ERROR,
    //   },
    // })

    app.config.errorHandler = (err: any) => {
      console.error('err', err)
      // captureException(err)
    }
  },
}

export default umengPlugin
